import axios from "./axios-handler.service";
const BASE_URL = "/api/ContaCorrenteParceiros";
export interface ContaCorrenteParceiro {
  idContaCorrenteParceiro: string;
  idConsultor: number;
  idPlano: number;
  descricao: string;
  data: Date;
  valor: number;
  saldoAnterior: number;
  saldoAtual: number;
  idConsultorPlano: number;
  consultorPlano: string;
  nomePlano: string;
  valorPlano: number;
  descontoPlano: number;
  dataExpiracaoPlano: Date;
}

export class ContaCorrenteParceirosService {
  static async efetuarSaque(idConsultor: number, valor: number) {
    if (valor > 0) {
      valor *= -1;
    }
    const response = await axios.post(`${BASE_URL}/EfetuarSaque`, {
      idConsultor,
      valor,
    });
    return response.data;
  }
  static async obterCompleto(id: string): Promise<ContaCorrenteParceiro> {
    const response = await axios.get<ContaCorrenteParceiro>(
      `${BASE_URL}/ObterCompleto`,
      {
        params: {
          idContaCorrenteParceiro: id,
        },
      }
    );
    return response.data;
  }
  static async listarContaCorrenteParceiro(
    idConsultor: number
  ): Promise<ContaCorrenteParceiro[]> {
    const response = await axios.get<ContaCorrenteParceiro[]>(
      `${BASE_URL}/ListarContaCorrenteParceiro`,
      {
        params: {
          idConsultor: idConsultor,
        },
      }
    );
    return response.data;
  }
}
